import { Box, Checkbox, TableCell } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cell: {
    whiteSpace: 'nowrap',
  },
}));

function OptionCell({ children }) {
  const classes = useStyles();

  return (
    <TableCell className={classes.cell} align="center">
      <Box display="flex" alignItems="center" justifyContent="center">
        {children}
      </Box>
    </TableCell>
  );
}

// Placeholder for letters beyond the number of options the question has.
export function UnavailableOptionCell() {
  return (
    <OptionCell>
      <Checkbox color="secondary" disabled />
    </OptionCell>
  );
}

export function EditableOptionCell({ checked, onSelect, disabled }) {
  return (
    <OptionCell>
      <Checkbox checked={checked} onChange={onSelect} disabled={disabled} />
    </OptionCell>
  );
}

// Shows whether the student picked this option and, if so, whether it was right.
export function ResultOptionCell({ chosen, correct }) {
  return (
    <OptionCell>
      {!chosen && <Checkbox disabled />}
      {chosen && correct && <Check color="primary" />}
      {chosen && !correct && <Close color="secondary" />}
    </OptionCell>
  );
}
